import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 }
    },
    routes: [
        {
            path: '',
            component: () =>
                import ('@/layouts/full-page/FullPage.vue'),
            children: [
                {
                    path: '/',
                    name: 'page-login',
                    component: () =>
                        import ('@/views/pages/Login.vue')
                },
                {
                    path: '/pages/error-404',
                    name: 'page-error-404',
                    component: () =>
                        import ('@/views/pages/Error404.vue')
                }
            ]
        },

        {
            path: '',
            component: () =>
                import ('./layouts/main/Main.vue'),
            children: [
                {
                    path: '/home',
                    name: 'home',
                    component: () =>
                        import ('./views/ScreenMeeting.vue')
                },
                {
                    path: '/usuarios',
                    name: 'usuarios',
                    component: () =>
                        import ('./views/Usuarios.vue')
                },
                {
                    path: '/asesores',
                    name: 'asesores',
                    component: () =>
                        import ('./views/advisers/screen.vue')
                },
            ]
        },
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ]
})

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = 'none'
    }
})

export default router